module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lte-progress progress",
    class: ['progress-' + _vm.size, {
      active: _vm.active,
      vertical: _vm.vertical
    }]
  }, [_c('div', {
    staticClass: "progress-bar",
    class: ['progress-bar-' + _vm.type, {
      'progress-bar-striped': _vm.striped
    }],
    style: (_vm.progressBarStyle)
  }), _vm._v(" "), _c('div', {
    staticClass: "progress-text"
  }, [_vm._v(_vm._s(_vm.text))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1f46e7a7","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/progress/progress.vue
// module id = 22
// module chunks = 0